import { locationSuggestions } from "../api";

export const SET_SUGGESTIONS = "SET_SUGGESTIONS";

export function fetchLocationSuggestions(input, dispatch) {
	locationSuggestions(input).then(suggestions => {
		dispatch({ type: SET_SUGGESTIONS, suggestions, input });
	});
}
